/**
 * Created by ejt on 04.10.2016.
 */


'use strict';
angular.module('betosyswebapp').controller('ToastErrorCtrl', ['$scope', '$mdToast', 'msg', 'type', '$rootScope', '$document', '$timeout', function ($scope, $mdToast, msg, type, $rootScope, $document, $timeout) {// //, $mdToast, $mdDialog) {
  $scope.errorAlert = {};

  $scope.errorAlert.message = msg;
  $scope.errorAlert.type = type;

  $scope.closeToast = function () {


    $mdToast
      .hide('Ok', {closeAll: true});

    //wait for animation if everything goes right
    $timeout(function () {
      //somehow toasts are not removed reliably sometimes - reason unknown
      //remove all toast elements after $mdToast.hide(..)
      var elements = $('md-toast');
      //elements is empty if everything works fine
      for (var index in elements) {
        if (elements.hasOwnProperty(index)) {
          try {
            if (elements[index] && elements[index].parentNode) {
              elements[index].parentNode.removeChild(elements[index]);
            }
          } catch (e) {
            console.log(e);
          }
        }
      }
    }, 300);
  };
}]);



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/toastErrorController.js